import { getCurrentAdminRbacPermissionsOptions } from '@gozoki/api'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ScrollArea } from '~/components/ui/scroll-area'
import { createAppAbility } from '~/utils/ability'
import { AppSidebar } from '../../components/new/navigation/app-sidebar'
import { SidebarInset, SidebarProvider } from '../../components/ui/sidebar'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
  beforeLoad: async ({ context }) => {
    const rbacPermissions = await context.queryClient.ensureQueryData(
      getCurrentAdminRbacPermissionsOptions(),
    )

    const ability = createAppAbility(rbacPermissions.grants, rbacPermissions.grantsV2, {
      enforcementEnabled: rbacPermissions.enforcementEnabled,
      permissionV2Enabled: rbacPermissions.permissionV2Enabled,
    })

    return { ability }
  },
})

function AuthenticatedLayout() {
  return (
    <div className="h-screen max-h-screen overflow-hidden leading-none">
      <ScrollArea className="h-full" scrollBarClassName="mr-px">
        <SidebarProvider defaultOpen={false}>
          <AppSidebar />
          {/* overflow-x-clip (pas overflow-hidden ni overflow-x-hidden) : le clip horizontal reste, mais
              le contenu qui dépasse en HAUTEUR remonte jusqu'à la ScrollArea du shell au lieu d'être
              rogné — sinon une page plus haute que le viewport (ex. dashboard RH avec cartes à
              min-height) se fait couper par le bas sans pouvoir scroller. `clip` plutôt que `hidden`
              car `hidden` fait de cet élément un scroll container : les enfants `position: sticky`
              s'ancreraient alors sur lui (qui ne scrolle jamais) au lieu de la ScrollArea du shell. */}
          <SidebarInset className="m-2 overflow-x-clip">
            <Outlet />
          </SidebarInset>
        </SidebarProvider>
      </ScrollArea>
    </div>
  )
}
